import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { numStr, t, translateDate } from '../../../components/common/Translate';
import { Record } from '../../../config/Record/RecordEntity';
import { RECORD_STATUS } from '../../../config';
import { Auth, recordActions } from '../../../config/configuration/react';
import { currencySign } from '../../../Utils/currencySign';

const { expertise_finished } = RECORD_STATUS;

export const usePricing = (recordId) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const roleId = Auth.roleId();
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const recordStatus = useSelector((state) => state.reduxRecords.data[recordId])?.record?.statusId;
  let supervisorOffer = useSelector((state) => state.reduxRecords.data[recordId])?.supervisor?.c2bOffer;
  const country = useSelector((state) => state.reduxRecords.data[recordId])?.record?.country;
  const countryPosId = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.countryId);
  if (supervisorOffer > 0) supervisorOffer = currencySign(Math.round(supervisorOffer), null, countryPosId);
  else supervisorOffer = '';

  const monkReportStatus = useSelector((state) => state.reduxRecords.data[recordId]?.monkReportStatus || []);
  const caMonkReportStatus = useSelector(
    (state) => state.reduxRecords.data[recordId]?.counterInspection?.monkReportStatus || [],
  );
  const supervisorComment = useSelector((state) => state.reduxRecords.data[recordId])?.supervisor?.comment;
  const supervisorAuthorized =
    useSelector((state) => state.reduxRecords.data[recordId])?.supervisor?.authorization === 'Y';

  const supervisorRefused =
    useSelector((state) => state.reduxRecords.data[recordId])?.supervisor?.authorization === 'N';

  let coveragePrice = useSelector((state) => state.reduxRecords.data[recordId]?.coverage?.coveragePrice);
  if (coveragePrice > 0) coveragePrice = currencySign(numStr(coveragePrice), null, countryPosId);
  else coveragePrice = '';
  let expertiseEndedAt = useSelector((state) => state.reduxRecords.data[recordId]?.expertise?.expertiseEndedAt);
  expertiseEndedAt = _.get(expertiseEndedAt, 'date', null);
  const recordEntity = new Record(record);
  const isVisible = recordEntity.pricingIsVisible();
  const active = Auth.isAllowedToAccessPricing() && isVisible && country !== 'NL';
  const showAutoPricing = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.autoPricing,
  );

  const suggestedPrice = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.suggestedPrice);
  const versionsAvailable = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.versionsData) || [];
  const valuationVersionId = useSelector((state) => state.reduxRecords.data[recordId]?.valuation?.versionId);
  const vehicleVersionId = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.versionId);
  const currentVersion = valuationVersionId || vehicleVersionId || versionsAvailable?.[0]?.id;
  const suggestedVersionId = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.suggestedVersionId);
  const suggestedVersionName =
    suggestedVersionId && versionsAvailable.filter((v) => v.id === suggestedVersionId)?.[0]?.name;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAiReport, setisOpenAiReport] = useState(false);
  const entryStockOptions = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption;
  let suggestedEntryStockDate = useSelector(
    (state) => state.reduxRecords.data[recordId]?.supervisor?.suggestedEntryStockDate?.date,
  );
  suggestedEntryStockDate =
    (suggestedEntryStockDate && moment(suggestedEntryStockDate).format('DD/MM/YYYY')) ||
    moment(entryStockOptions?.[0]?.[0]).format('DD/MM/YYYY');
  const suggestedMileage = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.suggestedMileage);
  const startTimeHours = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.startTimeHours,
  );
  const startTimeMinutes = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.startTimeMinutes,
  );
  const onClick = () => setIsOpen((prev) => !prev);
  const onClickAiReport = () => setisOpenAiReport((prev) => !prev);

  const getSuggestedPrice = async () => {
    if (currentVersion && entryStockOptions)
      await dispatch(recordActions.fetchPricing(recordId, null, null, null, currentVersion, 'suggestedPrice'));
  };

  useEffect(() => {
    if (suggestedPrice || !showAutoPricing) return;
    if (
      expertiseEndedAt &&
      moment(expertiseEndedAt).add(startTimeHours, 'hours').add(startTimeMinutes, 'minutes').diff(moment()) <= 0
    )
      getSuggestedPrice();
  }, [expertiseEndedAt, currentVersion, entryStockOptions, suggestedPrice, showAutoPricing]);

  const goToPricing = (e) => {
    if (!active) return;
    if (!['Tooltip-seggestedPrice', 'Tooltip-titleAi'].includes(e.target.id)) {
      if (roleId === 1) {
        dispatch(recordActions.changeCurrentTab('coverageRequest'));
      }
      history.push({
        pathname: `/files/${recordId}/pricing`,
        state: {
          ...history.location.state,
        },
      });
    }
  };

  const aiReport = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.aiReport);
  const dateOfOfReport = monkReportStatus?.timestamp?.date;
  const formattedDate = translateDate(dateOfOfReport, t('DD/MM/YYYY'));

  return {
    supervisorAuthorized,
    supervisorRefused,
    expertiseFinished: recordEntity.status() === expertise_finished,
    supervisorOffer,
    supervisorComment,
    goToPricing,
    isVisible,
    active,
    coveragePrice,
    permissionFord: Auth.isAllowedToAccessFord(),
    suggestedPrice: showAutoPricing && suggestedPrice ? numStr(suggestedPrice) : false,
    isOpen,
    onClick,
    suggestedMileage: suggestedMileage && numStr(suggestedMileage),
    suggestedEntryStockDate,
    suggestedVersionName,
    monkReportStatus,
    aiReport,
    formattedDate,
    onClickAiReport,
    isOpenAiReport,
    countryPosId,
    caMonkReportStatus,
    recordStatus,
  };
};
